import { ITaxCodeResponseData } from '@modules/front-office/interface/room-posting-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ITaxCodeResponseData = { dataResult: [] };

export const ACCGTaxCodeSlice = createSlice({
  name: 'accgTaxCode',
  initialState,
  reducers: {
    setACCGTaxCode: (_state, action: PayloadAction<ITaxCodeResponseData>) => {
      return action.payload;
    },
    removeACCGTaxCode: () => {
      return initialState;
    },
  },
});

export default ACCGTaxCodeSlice.reducer;

export const { setACCGTaxCode, removeACCGTaxCode } = ACCGTaxCodeSlice.actions;
